import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CurrencyComponent } from '../../shared/components/price/currency.component';
import { PriceCurrencyPipe } from "../../shared/pipes/priceCurrency/price-currency.pipe";

@Component({
  selector: 'app-product-price',
  standalone: true,
  templateUrl: './product-price.component.html',
  styleUrls: ['./product-price.component.scss'],
  imports: [
    CommonModule,
    CurrencyComponent,
    PriceCurrencyPipe,
  ],
})
export class ProductPriceComponent implements OnInit {
  constructor() {}

  @Input() price: number;
  @Input() isMinimalPrice: boolean = false;
  @Input() oldPrice: number | null = null;

  discount: number = 0;

  ngOnInit(): void {
    if(this.oldPrice) {
      this.discount = Math.round((1 - this.price / this.oldPrice) * 100);
    }
  }
}
